<!-- <div class="main_container row"> -->
<div class="d-flex justify-content-center mt-md-5 pt-md-5">

    <div class="col col-md-6 col-lg-3 mt-5 mx-auto">
        <mat-card class="border border-2 border-secondary shadow-none">
            <h3 class="text-secondary text-center">Área del Tutor</h3>
            <form [formGroup]="formLogin" (ngSubmit)="login()" class="mt-3">
                <div class="d-flex flex-column">
                    <div class="my-2 text-center">
                        <span class="fs-5 m-0">Correo electrónico</span>
                        <div class="input-group">
                            <input class="form-control fs-5 mt-2" formControlName="email">
                        </div>
                    </div>
                    <div class="my-2 text-center">
                        <span class="fs-5 m-0">Contraseña</span>
                        <div class="input-group">
                            <input class="form-control fs-5 mt-2" type="password" formControlName="password">
                        </div>
                    </div>
                    <div class="form-check my-2 fs-5 text-center">
                        <mat-checkbox class="example-margin" formControlName="rememberMe">Recuérdame
                        </mat-checkbox>
                    </div>

                    <button class="fs-5 m-0" type="submit" mat-raised-button color="accent">Log in</button>

                    <a [routerLink]="['/password-reminder']"
                        class="fs-5 text-decoration-underline text-dark mt-3 text-center">¿Olvidaste tu
                        contraseña?</a>
                </div>
            </form>
        </mat-card>
    </div>

</div>